// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import icon from 'images/home-database-management-icon.png'
import antennaIcon from 'images/path-details-antenna.png'
import pathImage from 'images/path-details-site.png'
import radioIcon from 'images/path-details-radio.png'
import databaseManagementBg from 'images/home-database-management-bg.jpg'

import {
  DatabaseSections,
  DecoratedLink,
  SubtreeHeading,
  SubtreeIcon,
  SubtreeSectionWrapper,
} from './styles'

const DatabaseManagement = () => (
  <SubtreeSectionWrapper bgImage={databaseManagementBg}>
    <div className={'position-relative display-flex justify-content-center align-items-center flex-direction-column'}>
      <SubtreeIcon
        alt={'Database Management Icon'}
        src={icon}
        style={{ filter: 'drop-shadow(.125em .125em .125em #335c84)' }} />
      <SubtreeHeading
        className={'margin-top-1'}
        style={{ filter: 'drop-shadow(.125em .125em .125em #335c84)' }}>
        {'Database Management'}
      </SubtreeHeading>
      <DatabaseSections>
        <DecoratedLink
          id={'home-cta-database-management-path'}
          to={'/database-management/path'}>
          <img
            alt={'home page cta path icon'}
            className={'margin-right-half'}
            src={pathImage} />
          <span className={'link-text'}>
            {'Path'}
          </span>
        </DecoratedLink>
        <DecoratedLink
          id={'home-cta-database-management-antenna'}
          to={'/database-management/antenna'}>
          <img
            alt={'home page cta antenna icon'}
            className={'margin-right-half'}
            src={antennaIcon} />
          <span className={'link-text'}>
            {'Antenna'}
          </span>
        </DecoratedLink>
        <DecoratedLink
          id={'home-cta-database-management-radio'}
          to={'/database-management/radio'}>
          <img
            alt={'home page cta radio icon'}
            className={'margin-right-half'}
            src={radioIcon}
            style={{ transform: 'translateY(-20%)' }} />
          <span className={'link-text'}>
            {'Radio'}
          </span>
        </DecoratedLink>
      </DatabaseSections>
    </div>
  </SubtreeSectionWrapper>
)

export default DatabaseManagement
